/** @jsx jsx */
import { css, jsx } from "@emotion/core"

import { Button } from "@cd2/components/build/es6"
import React from "react"
import { IComponentProps, IxRef } from "@cd2/tools/build/es6"
import { CancelButton } from "./CancelButton"

export function ConfirmCancelButtons({
  onConfirm,
  onCancel,
  buttonOpts,
  disabled,
  cancelButtonRef,
  confirmText,
}: {
  onConfirm: ((e: any) => void) | "submit"
  onCancel(): void
  disabled?: boolean
  buttonOpts?: {
    confirm?: Partial<IComponentProps<typeof Button>>
    cancel?: Partial<IComponentProps<typeof Button>>
  }
  cancelButtonRef?: IxRef<HTMLDivElement>
  confirmText?: string
}) {
  return (
    <div
      css={css`
        > * {
          margin-right: 8px;
        }
      `}
    >
      {typeof onConfirm === "string" ? (
        <Button
          children={confirmText || "Confirm"}
          buttonProps={{ type: "submit" }}
          disabled={disabled}
          {...(buttonOpts?.confirm ?? {})}
        />
      ) : (
        <Button
          children={confirmText || "Confirm"}
          onClick={onConfirm}
          {...(buttonOpts?.confirm ?? {})}
        />
      )}

      <CancelButton
        xRef={cancelButtonRef}
        onClick={onCancel as any}
        buttonColor="white"
        disabled={disabled}
        {...(buttonOpts?.cancel ?? {})}
      />
    </div>
  )
}
